import { PublicCategory } from '../../../categories/types/public-category.type';
import { PUBLIC_PRODUCTS_APP_PATHS } from '../../../products/constants/public-products-paths.constants';
import { BASE_PUBLIC_V2_PATH } from '../constants/path.constants';

export function resolveHomeLink(loading: boolean, categories: PublicCategory[]): string {
  if (loading || categories.length === 0) return BASE_PUBLIC_V2_PATH;

  return PUBLIC_PRODUCTS_APP_PATHS.CATALOG_FOR(categories[0].slug);
}
